import { NQError } from "@visonum/network-quality-sdk";
import errorToSeverityLevel from "./errorToSeverityLevel";
import getTagsForNqError from "./getTagsForNqError";
import sentryObject from "./sentryObject";

export const sentryCaptureError = (error: Error) => {
    if (error instanceof NQError) {
        sentryObject.captureException(error, {
            tags: getTagsForNqError(error, null),
            level: errorToSeverityLevel(error),
        });
    } else {
        sentryObject.captureException(error);
    }
}

export default sentryCaptureError;